<p-dialog
  #pdfViewer
  [modal]="true"
  [visible]="true"
  [style]="{ width: '100rem', height: '100rem' }"
  [position]="'top'"
  (visibleChange)="matDialogRef.close()"
  [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }"
  [maximizable]="true"
  [closable]="true"
  [responsive]="true"
  [closeOnEscape]="false"
  [dismissableMask]="false"
>
  <ng-template pTemplate="header">
    <div class="flex align-items-center">
      <i class="pi pi-fw pi-print mr-2 text-primary"></i>
      <span class="font-light fs-large">Visualização de arquivo gerado</span>
    </div>
  </ng-template>
  <div class="pdf-viewer-wrapper">
    <aside class="pdf-sidebar" [class.hidden]="!showSidebar">
      <div class="thumbnails-scroll" #sidebar></div>
    </aside>
    <div class="pdf-main">
      <div class="pdf-actions">
        <div class="pdf-controls">
          <button
            (click)="toggleSidebar()"
            pButton
            pRipple
            severity="primary"
            rounded
            text
            icon="pi pi-bars"
            pTooltip="Mostrar/Esconder miniaturas"
          ></button>

          <!-- <button
        (click)="goToPreviousPage()"
        [disabled]="currentPage === 1"
        pButton
        pRipple
        severity="primary"
        rounded
        text
        icon="pi pi-chevron-left"
      ></button>
      <span class="page-info">{{ currentPage }} / {{ totalPages }}</span>
      <button
        (click)="goToNextPage()"
        [disabled]="currentPage === totalPages"
        pButton
        pRipple
        severity="primary"
        rounded
        text
        icon="pi pi-chevron-right"
      ></button> -->
        </div>
        <div class="pdf-controls">
          <div class="page-input-container">
            <input
              #inputPage
              type="number"
              class="page-input"
              (click)="inputPage.select()"
              [(ngModel)]="pageInput"
              (keyup.enter)="onPageInputChange($event)"
              (blur)="onPageInputChange($event)"
              [min]="1"
              [max]="totalPages"
              (keydown)="preventInvalidCharacters($event)"
              (paste)="preventPaste($event)"
            />
            <span class="font-bold fs-normal text-white">
              / {{ totalPages }}
            </span>
          </div>
          <button
            (click)="zoomOut()"
            pButton
            pRipple
            severity="primary"
            rounded
            text
            icon="pi pi-search-minus"
            pTooltip="Zoom -"
          ></button>

          <div class="zoom-input-container">
            <input
              #zoomInput
              type="number"
              class="zoom-input"
              [(ngModel)]="zoomPercent"
              (change)="onZoomInputChange()"
              (click)="zoomInput.select()"
              min="25"
              max="500"
              step="5"
            />
            <span class="zoom-suffix">%</span>
          </div>

          <button
            (click)="zoomIn()"
            pButton
            pRipple
            severity="primary"
            rounded
            text
            icon="pi pi-search-plus"
            pTooltip="Zoom +"
          ></button>
        </div>
        <div class="pdf-controls">
          <button
            (click)="printPdf()"
            pButton
            pRipple
            severity="primary"
            rounded
            text
            icon="pi pi-print"
            pTooltip="Imprimir"
          ></button>
          <button
            (click)="downloadPdf()"
            pButton
            pRipple
            severity="primary"
            rounded
            text
            icon="pi pi-download"
            pTooltip="Baixar PDF"
          ></button>
        </div>
      </div>
      <div class="pdf-loading" *ngIf="isLoading">
        <p-progressSpinner
          strokeWidth="4"
          styleClass="custom-spinner"
        ></p-progressSpinner>
      </div>
      <div #pdfContainer class="pdf-canvas-container"></div>
    </div>
  </div>
</p-dialog>
